import { createSlice } from '@reduxjs/toolkit';
import { getCoursesOfStudent, getDetailCourse, getListCourses, getModulesOfCourse } from './courseThunk';
import { ICoursesDetail } from '~/utils/interface/course';
import { IModule } from '~/utils/interface/course';

interface CourseState {
  courses: IModule[];
  nextCourses: IModule | null;
  coursesDetail: ICoursesDetail;
}

const initialState: CourseState = {
  courses: [],
  nextCourses: null,
  coursesDetail: {} as ICoursesDetail,
};

const courseSlice = createSlice({
  name: 'courseSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.courses = action.payload;
      state.coursesDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Get List Courses
    builder
      .addCase(getListCourses.pending, (state) => {})
      .addCase(getListCourses.fulfilled, (state, action) => {
        if (action.payload.data.length > 0) {
          state.nextCourses = action.payload.data[0];
          state.courses = action.payload.data.slice(1);
        }
      })
      .addCase(getListCourses.rejected, (state) => {});

    // Get Detail Courses
    builder
      .addCase(getDetailCourse.pending, (state) => {})
      .addCase(getDetailCourse.fulfilled, (state, action) => {
        state.coursesDetail = action.payload.data;
      })
      .addCase(getDetailCourse.rejected, (state) => {});

    // Get List Courses Of Student
    builder
      .addCase(getCoursesOfStudent.pending, (state) => {})
      .addCase(getCoursesOfStudent.fulfilled, (state) => {})
      .addCase(getCoursesOfStudent.rejected, (state) => {});

    // Get List Modules Of Course
    builder
      .addCase(getModulesOfCourse.pending, (state) => {})
      .addCase(getModulesOfCourse.fulfilled, (state) => {})
      .addCase(getModulesOfCourse.rejected, (state) => {});
  },
});

// Actions
export const courseAction = courseSlice.actions;

// Reducer
const courseReducer = courseSlice.reducer;
export default courseReducer;
